export const statusCircleStyles = {
  container: {
    display: 'flex',
    px: 1,
    gap: 1,
    alignItems: 'center',
  },
  circle: (backgroundColor: string) => ({
    height: '16px',
    width: '16px',
    minWidth: '16px',
    minHeight: '16px',
    borderRadius: '50%',
    backgroundColor,
  }),
};
